"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTagRallyTeamsProperty = exports.tagRallyTeamsPropertyDefinition = void 0;
exports.tagRallyTeamsPropertyDefinition = {
    name: 'tag-rally-teams',
    type: 'asset',
    multiple: true,
    view: {
        hint: 'Related to a rally team? Tag it and the asset shows on the rally team collection page.',
        label: 'Rally Teams',
        style: '',
    },
    constraints: [
        {
            name: 'stencils',
            argument: ['rally-team'],
        },
    ],
};
const isTagRallyTeamsProperty = (prop) => {
    return prop.name === exports.tagRallyTeamsPropertyDefinition.name;
};
exports.isTagRallyTeamsProperty = isTagRallyTeamsProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFnLXJhbGx5LXRlYW1zLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvdGFnLXJhbGx5LXRlYW1zLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsK0JBQStCLEdBQUc7SUFDN0MsSUFBSSxFQUFFLGlCQUFpQjtJQUN2QixJQUFJLEVBQUUsT0FBTztJQUNiLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFO1FBQ0osSUFBSSxFQUFFLHdGQUF3RjtRQUM5RixLQUFLLEVBQUUsYUFBYTtRQUNwQixLQUFLLEVBQUUsRUFBRTtLQUNWO0lBQ0QsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsQ0FBQyxZQUFZLENBQUM7U0FDekI7S0FDRjtDQUM4QixDQUFBO0FBSTFCLE1BQU0sdUJBQXVCLEdBQUcsQ0FBQyxJQUFrQixFQUFpQyxFQUFFO0lBQzNGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyx1Q0FBK0IsQ0FBQyxJQUFJLENBQUE7QUFDM0QsQ0FBQyxDQUFBO0FBRlksUUFBQSx1QkFBdUIsMkJBRW5DIn0=